<header class="header-area"
        [ngClass]="{'d-none' : router.url === '/coming-soon'}">

    <!-- Top Header Area -->
    <div class="top-header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <ul class="header-left-content">

                        <!--<li><a routerLink="/tracking"><i class='bx bx-box'></i> {{'Track_your_Order' | translate }}</a></li>-->
                        <!--<li><a href="tel:+96897676711" style="direction:ltr">{{'Support' | translate }}: 97676711</a></li>-->

                    </ul>
                </div>
                <div class="col-lg-4 col-md-12">
                    
                </div>
            </div>
        </div>
    </div>

    <!-- Middle Header Area -->
    <div class="middle-header"
         [ngClass]="{'middle-header-style-two' : router.url === '/'}">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-3 col-md-3 d-none d-lg-block">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/logo/logo.png" alt="Image" style="height: 45px;">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <form class="search-box">
                        <input type="text" name="serachName" #serachName placeholder="{{'Search_Products.' | translate }}" class="form-control">
                        <button type="submit" class="search-btn" style="margin-top:2px" (click)="openSearch(serachName.value)"><i class="ri-search-line"></i> {{'Search' | translate }}</button>
                    </form>
                </div>
                <div class="col-lg-3 col-md-3" style="display: flex; justify-content: end;">
                    <div class="header-right-content d-none d-lg-block">
                        <ul>

                            <li>
                                <div class="dropdown language-switcher">
                                    <button class="dropdown-toggle" type="button" (click)="toggleClassLang($event)">
                                        <img src="{{CurrentLangSrc}}" alt="image">
                                        <span>{{CurrentLangName}} <i class='bx bx-chevron-down'></i></span>
                                    </button>
                                    <div class="dropdown-menu" [class.active]="classAppliedLang">
                                        <button (click)="setLang($event)" class="dropdown-item d-flex align-items-center">
                                            <img src="{{SecondLangSrc}}" class="shadow-sm" alt="flag">
                                            <span>{{SecondLangName}}</span>
                                        </button>

                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <!-- Navbar Area -->
    <div class="navbar-area"
         [ngClass]="{'sticky': isSticky}">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light" [class.active]="classApplied">
                <a class="navbar-brand" routerLink="/"><img src="assets/img/logo/logo.png" alt="logo" style="height:45px"></a>

                <div class="language-switcher d-block d-lg-none">
                        <button class="dropdown-toggle" type="button" (click)="toggleClassLang($event)">
                            <img src="{{CurrentLangSrc}}" alt="image">
                            <!--<span>{{CurrentLangName}} <i class='bx bx-chevron-down'></i></span>-->
                        </button>
                        <div class="dropdown-menu" [class.active]="classAppliedLang">
                            <button (click)="setLang($event)" class="dropdown-item d-flex align-items-center">
                                <img src="{{SecondLangSrc}}" class="shadow-sm" alt="flag">
                                <span>{{SecondLangName}}</span>
                            </button>
                        </div>
                </div>

                <div style="width: 95px; display: flex; justify-content: space-between; align-items: center; margin-left: 10px; margin-right: 10px;">



                    <div class="others-option d-inline-block d-lg-none">

                        <ul class="wish-cart">
                            <li>
                                <a routerLink="/cart">
                                    <span class="cart">
                                        <span class="wish-icon">
                                            <i class='bx bx-shopping-bag'></i>
                                            <span class="count" *ngIf="cartProducts.length != undefined">
                                                <b>
                                                    {{
                cartProducts.length
                                                    }}
                                                </b>
                                            </span>
                                        </span>
                                        <span class="favorite"> &nbsp; </span>

                                        &nbsp;

                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <button class="navbar-toggler" type="button" (click)="toggleClass($event)">
                        <span class="burger-menu">
                            <span class="top-bar"></span>
                            <span class="middle-bar"></span>
                            <span class="bottom-bar"></span>
                        </span>
                    </button>
                </div>

                <!--Categories-->
                <div class="navbar-category">
                    <button type="button" class="dropdown" (click)="toggleDropdown($event)" #dropdownRef><i class="ri-menu-line"></i> {{'All_Categories' | translate }} <i class="bx bx-chevron-down arrow-down ri-arrow-down-s-line"></i></button>
                    <div class="dropdown-content" [class.show]="isDropdownOpen">
                        <ul>


                            <li *ngFor="let product of categoryData; let rowIndex = index;" (click)="closeDropdown()">


                                <a [routerLink]="['/subcategory', { catID: product.gnCategoryID }]">

                                    <ng-template *ngIf="SelectedLanguage === 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                    </ng-template>
                                    <ng-template #other_ItemAr>{{ product.nameAr }}</ng-template>
                                    <ng-template #other_ItemEn>{{ product.name }}</ng-template>

                                </a>

                            </li>


                        </ul>
                    </div>

                </div>



                <!--Navs-->
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav">
                        <li class="nav-item clickable"><a routerLink="/home" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Home' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/discounts" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Discounts' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/occasions" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Occasions' | translate }}</a></li>
                        <!--<li class="nav-item clickable"><a routerLink="/about" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'About_Us' | translate }}</a></li>-->
                        <li class="nav-item clickable"><a routerLink="/shop" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Shop' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Contact' | translate }}</a></li>
                    </ul>
                    <div *ngIf="!classApplied" class="others-options d-none d-lg-inline-block">

                        <ul class="wish-cart">
                            <li>
                                <a routerLink="/cart">
                                    <span class="cart">
                                        <span class="wish-icon">
                                            <i class='bx bx-shopping-bag'></i>
                                            <span class="count" *ngIf="cartProducts.length != undefined">
                                                <b>
                                                    {{
                                    cartProducts.length
                                                    }}
                                                </b>
                                            </span>
                                        </span>
                                        <span class="favorite"> &nbsp; </span>

                                        &nbsp;

                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <ul class="navbar-nav for-responsive">



                        <li class="nav-item clickable"><a routerLink="/home" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'Home' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/discounts" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'Discounts' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/occasions" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'Occasions' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/about" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'About_Us' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/shop" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'Shop' | translate }}</a></li>
                        <li class="nav-item clickable"><a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleClass($event)">{{'Contact' | translate }}</a></li>


                        <li class="nav-item" [class.show]="isDropdownOpen">
                            <a href="#" class="nav-link" data-bs-toggle="dropdown" data-bs-offset="0,8" (click)="toggleDropdown($event)">
                                {{ 'All_Categories' | translate }}
                                <i class="bx" style="display: block;" [ngClass]="isDropdownOpen ? 'bx-plus plus-icon rotated' : 'bx-plus plus-icon'"></i>

                            </a>
                            <ul class="dropdown-menu2" [class.show]="isDropdownOpen">

                                <li class="nav-item" *ngFor="let product of categoryData; let rowIndex = index;">
                                    <a [routerLink]="['/subcategory', { catID: product.gnCategoryID }]"
                                       class="nav-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: false }"
                                       (click)="onCategoryClick($event)">
                                        <ng-template *ngIf="SelectedLanguage == 'ar'; then other_ItemAr; else other_ItemEn"></ng-template>
                                        <ng-template #other_ItemAr>{{ product.nameAr }}</ng-template>
                                        <ng-template #other_ItemEn>{{ product.name }}</ng-template>
                                    </a>
                                </li>
                            </ul>
                        </li>


                    </ul>


                </div>
            </nav>
        </div>
    </div>

</header>
